import { NgModule } from '@angular/core';

//Components
import { AppComponent } from './app.component';

//Modules
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtModule, JwtModuleOptions } from '@auth0/angular-jwt';
import { RouterModule } from '@angular/router';

//Providers
import { CookieService } from 'ngx-cookie-service';
import { TokenInterceptor } from './Interceptors/token.interceptor';
import { CommonModule } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NavmenuComponent } from './components/navmenu/navmenu.component';
import { routes } from './app.routes';


export function tokenGetter() {
  return sessionStorage.getItem('access_token');
}

const JWT_Module_Options: JwtModuleOptions = {
  config: {
    tokenGetter: tokenGetter,
    //whitelistedDomains: ['localhost:3001', 'foo.com', 'bar.com'],
    //blacklistedRoutes: ['localhost:3001/auth/'],
    throwNoTokenError: false
  }
};

@NgModule({
  //add in new components that are made here!!! Otherwise it would not route things this way 
  declarations: [
    AppComponent,
    
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    NavmenuComponent,
    FormsModule,
    JwtModule.forRoot(JWT_Module_Options),
    RouterModule.forRoot(routes, {  
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })
  ],
  providers: [
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync()
  ]
})
export class AppModule { }
